// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("src/foundations/font/AeonikPro-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("src/foundations/font/AeonikPro-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("src/foundations/font/AeonikPro-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("src/foundations/font/AeonikPro-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("src/foundations/font/AeonikPro-RegularItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("src/foundations/font/AeonikPro-RegularItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("src/foundations/font/AeonikPro-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("src/foundations/font/AeonikPro-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("src/foundations/font/AeonikPro-MediumItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("src/foundations/font/AeonikPro-MediumItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("src/foundations/font/AeonikPro-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("src/foundations/font/AeonikPro-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("src/foundations/font/AeonikPro-BoldItalic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("src/foundations/font/AeonikPro-BoldItalic.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*:root allows to use this rules from external*/
:host,
:root {
    --font-family: 'AeonikPro-Regular', "Aeonik Pro", Arial, sans-serif, monospace;
    color: var(--text-default);
    -webkit-font-smoothing: antialiased;
    /*Use CSS property font-feature-settings:'tnum' to select Aeonik Pro font's monospaced numbers typographic feature.*/
    font-feature-settings: "tnum";
    /* =============================================================================
    swift.com overrides and extra tokens
    ============================================================================= */
    --caption-bold-font-family: 'AeonikPro-Bold';
    --caption-bold-italic-font-family: 'AeonikPro-BoldItalic';
    --caption-bold-underlined-font-family: 'AeonikPro-Bold';
    --caption-regular-font-family: 'AeonikPro-Regular';
    --caption-regular-italic-font-family: 'AeonikPro-RegularItalic';
    --caption-regular-underlined-font-family: 'AeonikPro-Regular';
    --headings-display-font-family: 'AeonikPro-Light';
    --headings-h1-font-family: 'AeonikPro-Light';
    --headings-h2-font-family: 'AeonikPro-Regular';
    --headings-h3-font-family: 'AeonikPro-Medium';
    --headings-h4-font-family: 'AeonikPro-Medium';
    --p1-medium-font-family: 'AeonikPro-Medium';
    --p1-medium-italic-font-family: 'AeonikPro-MediumItalic';
    --p1-medium-underlined-font-family: 'AeonikPro-Medium';
    --p1-regular-font-family: 'AeonikPro-Regular';
    --p1-regular-italic-font-family: 'AeonikPro-RegularItalic';
    --p1-regular-strikethrough-font-family: 'AeonikPro-Regular';
    --p1-regular-underlined-font-family: 'AeonikPro-Regular';
    --p2-medium-font-family: 'AeonikPro-Medium';
    --p2-medium-italic-font-family: 'AeonikPro-MediumItalic';
    --p2-medium-underlined-font-family: 'AeonikPro-Medium';
    --p2-regular-font-family: 'AeonikPro-Regular';
    --p2-regular-italic-font-family: 'AeonikPro-RegularItalic';
    --p2-regular-strikethrough-font-family: 'AeonikPro-Regular';
    --p2-regular-underlined-font-family: 'AeonikPro-Regular';
}


@font-face {
    font-family: 'AeonikPro-Light';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
    font-weight: 300;
    font-display: swap;
}

@font-face {
    font-family: 'Aeonik Pro';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff');
    font-weight: 400;
    font-display: swap;
}
@font-face {
    font-family: 'AeonikPro-Regular';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff');
    font-weight: 400;
    font-display: swap;
}
@font-face {
    font-family: 'AeonikPro-RegularItalic';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff');
    font-weight: 400;
    font-style: italic;
    font-display: swap;
}
@font-face {
    font-family: 'AeonikPro-Medium';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff');
    font-weight: 500;
    font-display: swap;
}
@font-face {
    font-family: 'AeonikPro-MediumItalic';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('woff');
    font-weight: 500;
    font-display: swap;
}
@font-face {
    font-family: 'AeonikPro-Bold';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('woff');
    font-weight: 700;
    font-display: swap;
}
@font-face {
    font-family: 'AeonikPro-BoldItalic';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('woff');
    font-weight: 700;
    font-display: swap;
}


h1,
.h1{
    font-family: var(--headings-h1-font-family), sans-serif;
    font-size: var(--headings-h1-font-size);
    letter-spacing: var(--headings-h1-letter-spacing);
    line-height: var(--headings-h1-line-height);
    font-weight: var(--headings-h1-font-weight);
}
h2,
.h2{
    font-family: var(--headings-h2-font-family), sans-serif;
    font-size: var(--headings-h2-font-size);
    letter-spacing: var(--headings-h2-letter-spacing);
    line-height: var(--headings-h2-line-height);
    font-weight: var(--headings-h2-font-weight);
}
h3,
.h3{
    font-family: var(--headings-h3-font-family), sans-serif;
    font-size: var(--headings-h3-font-size);
    letter-spacing: var(--headings-h3-letter-spacing);
    line-height: var(--headings-h3-line-height);
    font-weight: var(--headings-h3-font-weight);
}
h4,
.h4{
    font-family: var(--headings-h4-font-family), sans-serif;
    font-size: var(--headings-h4-font-size);
    letter-spacing: var(--headings-h4-letter-spacing);
    line-height: var(--headings-h4-line-height);
    font-weight: var(--headings-h4-font-weight);
}

.d4 {
    font-family: var(--headings-display-font-family), sans-serif;
    font-size: var(--headings-display-font-size);
    letter-spacing: var(--headings-display-letter-spacing);
    line-height: var(--headings-display-line-height);
    font-weight: var(--headings-display-font-weight);
}
p,
.p1{
    font-family: var(--p1-regular-font-family), sans-serif;
    font-size: var(--p1-regular-font-size);
    letter-spacing: var(--p1-regular-letter-spacing);
    line-height: var(--p1-regular-line-height);
    font-weight: var(--p1-regular-font-weight);
}
.p1-m {
    font-family: var(--p1-medium-font-family), sans-serif;
    font-size: var(--p1-medium-font-size);
    letter-spacing: var(--p1-medium-letter-spacing);
    line-height: var(--p1-medium-line-height);
    font-weight: var(--p1-medium-font-weight);
}

.p2{
    font-family: var(--p2-regular-font-family), sans-serif;
    font-size: var(--p2-regular-font-size);
    letter-spacing: var(--p2-regular-letter-spacing);
    line-height: var(--p2-regular-line-height);
    font-weight: var(--p2-regular-font-weight);
}
.p2-m{
    font-family: var(--p2-medium-font-family), sans-serif;
    font-size: var(--p2-medium-font-size);
    letter-spacing: var(--p2-medium-font-family);
    line-height: var(--p2-medium-line-height);
    font-weight: var(--p2-medium-font-weight);
}

.caption {
    font-family: var( --caption-regular-font-family), sans-serif;
    font-size: var(--caption-regular-font-size);
    letter-spacing: var(--caption-regular-letter-spacing);
    line-height: var(--caption-regular-line-height);
    font-weight: var(--caption-regular-font-weight);
}
.caption-b {
    font-family: var(--caption-bold-font-family), sans-serif;
    font-size: var(--caption-bold-font-size);
    letter-spacing: var(--caption-bold-letter-spacing);
    line-height: var(--caption-bold-line-height);
    font-weight: var(--caption-bold-font-weight);
}
i {
    font-family: var(--p2-regular-italic-font-family), sans-serif;
    font-size: var(--p2-regular-italic-font-size);
    letter-spacing: var(--p2-regular-italic-letter-spacing);
    line-height: var(--p2-regular-italic-line-height);
    font-weight: var(--p2-regular-italic-font-weight);
    font-style: var(--p2-regular-italic-font-style);
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
